import { useEffect } from 'react';

/**
 * A hook to set the document title
 * @param title The title to set
 * @param resetOnUnmount Whether to reset the title to the default when the component unmounts
 */
export const useDocumentTitle = (title: string, resetOnUnmount = false) => {
  useEffect(() => {
    // Save the original title
    const originalTitle = document.title;
    
    // Set the new title
    document.title = title;
    
    // Reset the title when the component unmounts if resetOnUnmount is true
    return () => {
      if (resetOnUnmount) {
        document.title = originalTitle;
      }
    };
  }, [title, resetOnUnmount]);
};

/**
 * Default app title
 */
export const DEFAULT_TITLE = 'Gozango App';
